import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore from './data/store/configureStore';
import App from './ui/containers/AppContainer';

export default function start() {
    const store = configureStore();
    const rootEl = document.getElementById('newsletter-app');

    render(
        <AppContainer>
            <App store={store} />
        </AppContainer>,
        rootEl
    );

    if (module.hot) {
        module.hot.accept('./ui/containers/AppContainer', () => {
            render(
                <AppContainer>
                    <App store={store} />
                </AppContainer>,
                rootEl
            );
        });
    }
}
